import { FilledButton, OutlinedButton } from '../util/button';

interface AddInsuranceButtonFieldProps {
  disabled: boolean;
  addInsurance: () => void;
  cancelEntry: () => void;
}
export const AddInsuranceButtonField = ({
  disabled,
  addInsurance,
  cancelEntry,
}: AddInsuranceButtonFieldProps) => {
  const handleClickAddInsurance = () => addInsurance();
  const handleClickCancelEntry = () => cancelEntry();
  return (
    <div className={'add-insurance-button-field'}>
      <FilledButton
        onClick={handleClickAddInsurance}
        label={'保険情報を登録して再見積もり'}
        disabled={disabled}
      />
      <OutlinedButton onClick={handleClickCancelEntry} label={'キャンセル'} />
    </div>
  );
};
